import { useState } from 'react';
import { fetchApps } from '../../Ateam-BI/Templates/Utils/AppActivityUtils';

export const useBreadcrumb = () => {
    const [breadcrumbItems, setBreadcrumbItems] = useState([]);

    const generateBreadcrumbs = async (backUrl, deliverableRef, id, pid, workflowInstanceId, lpid) => {
        const getCachedApps = async () => {
            const cached = localStorage.getItem('appsCache');
            if (cached) {
                try {
                    const parsed = JSON.parse(cached);
                    return parsed.data;
                } catch (err) {
                    localStorage.removeItem('appsCache');
                }
            }
            try {
                const freshData = await fetchApps();
                const payload = {
                    timestamp: Date.now(),
                    data: freshData,
                };
                localStorage.setItem('appsCache', JSON.stringify(payload));
                return freshData;
            } catch (error) {
                console.error('Failed to fetch apps:', error);
                return null;
            }
        };
        
        const allApps = await getCachedApps();
        const currentApp = allApps?.find(app => app.app_id === id);
        const teamName = currentApp?.app_name || "Team";
        const appUrl = currentApp?.url
        
        const isCorpReporting = teamName === "Corporate Reporting Central" || backUrl === "Corporate Reporting Central";
        const isApprovals = deliverableRef === 'Approvals';
        
        const parentBreadcrumb = {
            text: isCorpReporting ? "Deliverables" : teamName,
            href: isCorpReporting ? "/CorpReportingHome/deliverables" : (appUrl || backUrl || `/app/${id}`)
        };
        
        let currentPageHref;
        if (isCorpReporting && isApprovals) {
            currentPageHref = '/ApprovalsHome';
        } else if(isApprovals) {
            deliverableRef = 'History'
            // Use lpid for Logico processes, otherwise use pid
            if (lpid) {
                currentPageHref = `/App/${id}/LogicoProcess/${lpid}/history`;
            } else if (pid) {
                currentPageHref = `/App/${id}/process/${pid}/history`;
            } else {
                currentPageHref = `/App/${id}`;
            }
        } else if (isCorpReporting || backUrl) {
            if (lpid) {
                currentPageHref = `/App/${id}/LogicoProcess/${lpid}/upload`;
            } else if (pid) {
                currentPageHref = `/App/${id}/process/${pid}/upload`;
            } else {
                currentPageHref = `/App/${id}`;
            }
        }
        
        const currentPageBreadcrumb = {
            text: deliverableRef,
            href: currentPageHref
        };
        
        const breadcrumbs = [parentBreadcrumb, currentPageBreadcrumb];
        
        if (workflowInstanceId) {
            breadcrumbs.push({ 
                text: workflowInstanceId, 
                href: `/ApprovalsHome/Workflow/${workflowInstanceId}` 
            });
        }
        
        setBreadcrumbItems(breadcrumbs);
    };

    return { breadcrumbItems, generateBreadcrumbs };
};